import Deepstream from "../libs/deepstream/deepstream";
import Preview from "../libs/deepstream/preview";

const getDefaultState = () => {
  return {
    uid: null,
    cid: null,
    standby: true,
    currentInteraction: null,
    currentInteractionState: null,
    disableUserInteraction: false
  };
};

export default {
  namespaced: true,

  state: getDefaultState(),

  mutations: {
    uid(state, uid) {
      state.uid = uid;
    },
    cid(state, cid) {
      state.cid = cid;
    },
    standby(state, standby) {
      state.standby = standby;
    },
    currentInteraction(state, currentInteraction) {
      state.currentInteraction = currentInteraction;
    },
    currentInteractionState(state, currentInteractionState) {
      state.currentInteractionState = currentInteractionState;
    },
    disableUserInteraction(state, disableUserInteraction) {
      state.disableUserInteraction = disableUserInteraction;
    },
    reset(state) {
      Object.assign(state, getDefaultState());
    }
  },

  getters: {},

  actions: {
    async login({ commit, rootState }) {
      const uid = `${
        rootState.app.config.cid
      }-preview-${Deepstream.getInstance().client.getUid()}`;
      const authInfo = await Deepstream.getInstance().login(uid, null);
      // login() returns undefined when the client is already OPEN; guard it
      if (authInfo) {
        commit("cid", authInfo.cid);
        commit("uid", authInfo.uid);
      }
    },
    async join({ commit }, recordName) {
      commit("reset");
      await Preview.getInstance().join(recordName);
    }
  }
};
